import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { setOverrideModal } from './actions/ticketActions'
import { getTranslation } from '../actions/dataActions'
import {
  toggleManualInput,
  clearValidationResult,
  validateTicket,
  setBarcode,
  clearBarcode,
  allowAccess
} from './actions/ticketActions'
import Ink from 'react-ink'
import * as resource from '../constants/Resources'
import TicketOverrideModal from './components/TicketOverrideModal'

const TicketScanner = props => {
  const {
    getTranslation,
    clearBarcode,
    clearValidationResult,
    validateTicket,
    posDeviceGuid,
    barcode,
    setBarcode,
    validationResult,
    setOverrideModal,
    allowAccess,
    isLoading,
    useManualInput,
    toggleManualInput,
    culture } = props;

  const showManualInput = () => {
    toggleManualInput(true);
  }

  const hideManualInput = () => {
    toggleManualInput(false);
  }

  const handleAllowAccess = () => {
    setOverrideModal(true, () => allowAccess(posDeviceGuid, barcode, culture));
  }

  const handleClear = () => {
    clearBarcode();
    clearValidationResult();
  }

  useEffect(() => {
    if (validationResult) {
      const timeoutID = setTimeout(function () {
        handleClear();
      }, 10000);

      return () => window.clearTimeout(timeoutID);
    }
  }, [validationResult]);

  const handleValidate = () => {
    clearValidationResult();
    var hasModalOpen = document.querySelectorAll('.customerBaseModal').length > 0 || document.querySelectorAll('.ticketBaseModal').length > 0 || document.querySelectorAll('.inputModal').length > 0;
    if (!isLoading && barcode && barcode.length > 0 && !hasModalOpen) {
      validateTicket(posDeviceGuid, barcode, culture);
    }
  }

  const onKeyDownHandler = e => {
    if (e.keyCode === 13) {
      handleValidate();
    }
  }

  return (
    <div className="ticket-scanner-component" onKeyDown={onKeyDownHandler}>
      {!useManualInput &&
        <div className="scan-barcode-message">{getTranslation(resource.SCAN_BARCODE)}</div>
      }
      {useManualInput &&
        <div className="manual-input">
          <input
            id="barcode"
            className="barcode"
            type="text"
            placeholder={getTranslation(resource.BARCODE)}
            onChange={e => setBarcode(e.target.value)}
            value={barcode}
          />
          <button type="button" className="scanbutton" onClick={handleValidate}>
            {getTranslation(resource.FETCH_TICKETS)}
            <Ink />
          </button>
        </div>
      }
      {validationResult &&
        <div id="ticketvalidation" className={`validation-result ${(validationResult.isValid ? "valid" : "invalid")}`}>
          {validationResult.message.split('\n').map(function(item, key) {
            return (
              <span key={key}>
                {item}
                <br/>
              </span>
            )
          })}
          <div className="clear-result-button" onClick={handleClear}>
            <i className="large window close icon" />
            <Ink />
          </div>
        </div>
      }
      <div className="action-buttons">        
        {validationResult &&
          <div className="action-button" onClick={handleClear}>
            <i className="large window close icon" />
            <Ink />
          </div>
        }
        {validationResult && !validationResult.isValid && validationResult.isOverridePossible &&
          <div className="action-button" onClick={handleAllowAccess}>
            <i className="large unlock icon" />
            <Ink />
          </div>
        }
        <div className="action-buttons-spacer"></div>
        {!useManualInput &&
          <div className="action-button" onClick={showManualInput}>
            <i className="large keyboard icon" />
            <Ink />
          </div>
        }
        {useManualInput &&
          <div className="action-button" onClick={hideManualInput}>
            <i className="large qrcode icon" />
            <Ink />
          </div>
        }
      </div>
      <TicketOverrideModal/>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    posDeviceGuid: state.generalState.uniqueid,
    barcode: state.ticket.barcode,
    validationResult: state.ticket.validationResult,
    isLoading: state.generalState.isLoading,
    useManualInput: state.ticket.useManualInput,
    reference: state.ticket.overrideModal.reference,
    culture: state.layoutState.language.culture
  }
}

export default connect(
  mapStateToProps, {
  getTranslation,
  clearValidationResult,
  validateTicket,
  setBarcode,
  clearBarcode,
  setOverrideModal,
  allowAccess,
  toggleManualInput
})(TicketScanner)



// WEBPACK FOOTER //
// src/ticket/TicketScanner.jsx